<template>
  <div class="base-info">
    <slot name="icon" />
    <div class="base-info__content"><slot /></div>
    <IconButton name="close" @click="$emit('close')" />
  </div>
</template>

<script lang="ts" setup>
  import { IconButton } from './IconButton'

  defineEmits(['close'])
</script>

<style>
  .base-info {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-content: stretch;
    align-items: center;
    padding: 0 8px;
    margin-bottom: 8px;
    font-size: 10px;
    background: #fff;
  }

  .base-info__content {
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    gap: 8px;
    padding: 10px 0;
    line-height: 12px;
  }
</style>
